import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { captureRtkQueryError } from '../../instrumentation/captureApiError';

type FetchBaseQueryConfig = Parameters<typeof fetchBaseQuery>[0];

/**
 * Wraps RTK `fetchBaseQuery` so failed requests are sent to Sentry (see `captureRtkQueryError`).
 */
export function createSentryFetchBaseQuery(
  config: FetchBaseQueryConfig
): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> {
  const baseQuery = fetchBaseQuery(config);
  const baseUrl = config && typeof config.baseUrl === 'string' ? config.baseUrl : '';

  return async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);
    if (result.error) {
      captureRtkQueryError(args, result.error, baseUrl);
    }
    return result;
  };
}
